export const CATEGORY_ARRAY = [
  ["Kierowcy", "drivers"],
  ["Inne", "others"],
]

export const LICENCES_ARRAY = [
  ["B", "B"],
  ["B+E", "BE"],
  ["C", "C"],
  ["C+E", "CE"],
  ["D", "D"],
  ["D+E", "DE"],
]

export const OTHERPOSITIONS_ARRAY = [
  ["Spedytor", "spedytor"],
  ["Dyspozytor", "dyspozytor"],
  ["Planista", "planista"],
  ["Handlowiec", "handlowiec"],
  ["Opiekun floty", "opiekunfloty"],
  ["Referent FK", "referentfk"],
  ["Budownictwo", "budownictwo"],
  ["Inny", "other"],
]
